// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b8381edf","952":"a90ea29f"}[chunkId] + ".chunk.js";
};